export default {"src":"/_next/static/media/gzr.d232ea3e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};